import { createSlice } from "@reduxjs/toolkit"
import {ensureWorkspaceTemplate} from "../utils/reduxUtilities"
import {loadWorkspace} from "./workspaceSlice"

const initialState = {
	value: "alpha"
}
const ensureWorkspace = (state, workspaceId) => ensureWorkspaceTemplate(state, workspaceId, initialState)
export const automatedSearchSortBySlice = createSlice({
	name: "automatedSearchSortBy",
	initialState: {
		byWorkspace: {},
	},
	reducers: {
		setAutomatedSearchSortBy: (state, action) => {
			const {newVal, workspaceId} = action.payload
			const workspace = ensureWorkspace(state, workspaceId)
			workspace.value = newVal
		},
	},
	extraReducers: (builder) => {
		builder.addCase(loadWorkspace.fulfilled, (state, action) => {
			const workspaceId = action.payload.workspace.id
			// when workspace loads in, if a value isn't already present, set the sort-by option to default "alphabetic".
			ensureWorkspace(state, workspaceId)
		})
	}
})

export const { setAutomatedSearchSortBy } = automatedSearchSortBySlice.actions

export const selectAutomatedSearchSortBy = (state, workspaceId) => state.automatedSearchSortBy.byWorkspace[workspaceId]?.value ?? initialState.value

export default automatedSearchSortBySlice.reducer
